<template>
  <div class="data_outline">
    <div class="outline_wrapper">
      <template v-if="isSubtitle">
        <div
          class="outline_item"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <template v-if="permission[item.permission]">
            <div class="frame_title">
              <div class="left_area">
                {{ item.subtitle }}
              </div>
              <div class="right_area"></div>
            </div>
            <div class="frame_wrapper">
              <template v-for="(el, index_) in item.subList">
                <div class="frame_content" :key="index_">
                  <div class="frame_content_label">{{ el.labelName }}</div>
                  <div class="frame_content_value">
                    {{
                      getHundredMillionMoney(
                        dataInfo[el.valueName],
                        el.isMoney
                      )
                    }}<span class="total_unit"> {{ el.totalUnit }}</span>
                  </div>
                  <div class="frame_content_contrast">
                    月&nbsp;<a-icon
                      class="right_icon"
                      type="caret-up"
                    />&nbsp;&nbsp;{{
                      getMillionMoney(dataInfo[el.valueName], el.isMoney)
                    }}
                    &nbsp;{{ el.monthTotalUnit }}
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
  <script>
import { mapGetters } from "vuex";
export default {
  name: "dataOutline",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["permission"]),
    //   权限

    // 亿元
    getHundredMillionMoney() {
      return function (info = { sum: 0, total: 0 }, isMoney = false) {
        if (!isMoney) {
          return info.total;
        }
        return this.getMoney(
          Math.round((Number(info.sum) / 100000000) * 100) / 100
        );
      };
    },

    // 万元
    getMillionMoney() {
      return function (info = { monthSum: 0, monthTotal: 0 }, isMoney = false) {
        if (!isMoney) {
          return info.monthTotal;
        }
        return this.getMoney(
          Math.round((Number(info.monthSum) / 10000) * 100) / 100
        );
      };
    },
  },
  props: {
    title: {
      type: String,
      default: "标题",
    },
    isSubtitle: {
      type: Boolean,
      default: false,
    },
    dataList: {
      type: Array,
      default: () => [],
    },
    dataInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {},

  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
$base_width: 375;
@function pxRem($px) {
  @return ($px / $base_width) * 10 + rem;
}
.data_outline {
  padding: pxRem(20) pxRem(20) 0 pxRem(20);
  position: relative;
  background: #ffffff;
  // margin-top: 10px;
  // border-radius: 8px;
  .outline_wrapper {
    .outline_item {
      flex: 1;
      margin-bottom: pxRem(20);
      .frame_title {
        display: flex;
        // height: pxRem(52);
        justify-content: space-between;
        align-items: center;
        position: relative;
        .left_area {
          position: relative;
          margin-left: pxRem(15);
          font-weight: 700;
          font-size: pxRem(13);
          color: #333;
          display: flex;
          align-items: center;
        }
        &::before {
          position: absolute;
          content: "";
          width: pxRem(5);
          height: pxRem(15);
          background: linear-gradient(#7EA2F1, #4D80F1);
          border-radius: pxRem(8);
          top: 50%;
          left: 0;
          transform: translateY(-50%);
        }
        .right_area {
          padding-right: pxRem(20);
        }
      }
      .frame_wrapper {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: pxRem(20);
        // padding: 0 pxRem(20);
        .border_line {
          width: 1px;
          background-color: #e9e9e9;
          height: pxRem(40);
        }
        .frame_content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          .frame_content_label {
            color: #333;
            font-size: pxRem(12);
            font-weight: 400;
          }
          .frame_content_value {
            font-size: pxRem(18);
            font-weight: 700;
            color: #333;
            margin-top: pxRem(10);
            margin-bottom: pxRem(10);
            .total_unit {
              font-weight: 700;
              font-size: pxRem(10);
              color: #999999;
            }
          }
          .frame_content_contrast {
            display: flex;
            align-items: center;
            font-size: pxRem(10);
            color: #999999;

            .right_icon {
              color: #f95e5a;
            }
          }
        }
      }
    }
  }
}
</style>